"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePinnedColumns = usePinnedColumns;
var _react = require("react");
function usePinnedColumns(_ref) {
  var _ref$statePinnedLeft = _ref.statePinnedLeft,
    statePinnedLeft = _ref$statePinnedLeft === void 0 ? [] : _ref$statePinnedLeft,
    columnsToRender = _ref.columnsToRender,
    coloredRow = _ref.coloredRow,
    checkboxSelection = _ref.checkboxSelection;
  return (0, _react.useMemo)(function () {
    var leftSet = new Set();
    var rightSet = new Set();
    columnsToRender.forEach(function (_ref2) {
      var configField = _ref2.configField,
        field = _ref2.field,
        fixed = _ref2.fixed,
        fixedRight = _ref2.fixedRight;
      if (fixed || statePinnedLeft.includes(configField)) {
        leftSet.add(field);
      } else if (fixedRight) {
        rightSet.add(field);
      }
    });
    var left = Array.from(leftSet);
    var right = Array.from(rightSet);
    return {
      left: left,
      right: right
    };
  }, [columnsToRender, statePinnedLeft.toString()]);
}